export const data = {
  debts: [
    {
      id: 1,
      name: "vivo",
      value: 123,
    },
    {
      id: 2,
      name: "itau",
      value: 843,
    },
  ],
  credit: [
    {
      id: 1,
      value: 1000,
    },
    {
      id: 2,
      value: 3000,
    },
  ],
  promotions: [
    {
      id: 1,
      type: "RG",
      value: 100,
    },
    {
      id: 2,
      type: "CPF",
      value: 80,
    },
  ],
};
